import React from 'react';
import { motion } from 'framer-motion';
import { Heart, ArrowRight } from 'lucide-react';

const CTASection = ({ 
  title = "Need support or want to help?",
  description = "Whether you need assistance or want to support our mission, we're here for you",
  primaryButtonText = "Get Support",
  primaryButtonLink = "/contact",
  secondaryButtonText = "Donate Now",
  secondaryButtonLink = "/donate",
  variant = "default"
}) => {
  const getVariantStyles = () => {
    switch(variant) {
      case "support":
        return {
          icon: <Heart className="w-6 h-6 inline-block mr-2" />,
          buttonText: "Talk to Someone Now"
        };
      case "donate":
        return {
          buttonText: "Support Our Mission"
        };
      default:
        return {
          buttonText: primaryButtonText
        };
    }
  };

  const variantStyles = getVariantStyles();

  return (
    <section className="cta-section">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.8, ease: "easeOut" }}
        className="cta-container"
      >
        <h2 className="cta-title">
          {title}
        </h2>
        <p className="cta-description">
          {description}
        </p>
        <div className="cta-buttons">
          <motion.a
            href={primaryButtonLink}
            className="cta-primary-button flex items-center"
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
          >
            {variantStyles.icon}
            {variantStyles.buttonText}
            <ArrowRight className="w-5 h-5 ml-2" />
          </motion.a>
          {secondaryButtonText && (
            <motion.a
              href={secondaryButtonLink}
              className="cta-secondary-button flex items-center"
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
            >
              {secondaryButtonText}
              <ArrowRight className="w-5 h-5 ml-2" />
            </motion.a>
          )}
        </div>
      </motion.div>
    </section>
  );
};

export default CTASection;